import { render, staticRenderFns } from "./LoginBindingPrompt.vue?vue&type=template&id=a0a26480&scoped=true"
import script from "./LoginBindingPrompt.vue?vue&type=script&lang=js"
export * from "./LoginBindingPrompt.vue?vue&type=script&lang=js"
import style0 from "./LoginBindingPrompt.vue?vue&type=style&index=0&id=a0a26480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a26480",
  null
  
)

export default component.exports